import { RepresentativeFields } from "@/components/shared/forms/RepresentativeFields";
import { usePositionOptions } from "@/presentation/hooks/usePositionOptions";
import { useRepresentativeLabels } from "@/presentation/hooks/useRepresentativeLabels";
import { WizardTextField } from "./WizardTextField";

export function CreateInvestorCompanyStep() {
  const positions = usePositionOptions();
  const labels = useRepresentativeLabels();
  return (
    <>
      <WizardTextField
        name="companyName"
        label="investors.attributes.company_name"
        placeholder="investors.wizard.placeholders.company_name"
        required
      />
      <div className="grid gap-(--card-gap) sm:grid-cols-2">
        <WizardTextField
          name="cif"
          label="investors.attributes.cif"
          placeholder="investors.wizard.placeholders.cif"
          required
        />
        <WizardTextField
          name="website"
          label="investors.attributes.website"
          placeholder="investors.wizard.placeholders.website"
        />
      </div>
      <RepresentativeFields name="representative" positions={positions} labels={labels} />
    </>
  );
}
